/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../components/GrayPanel';
import Paper from '../../../components/Paper';
import PaperTile from '../../../components/PaperTile';
import FormRow from '../../../components/FormRow';

import { fetchAvailableServices } from '../../../actions/eservices';
import { adminEndpoint } from '../../../config';

import s from './AvailableServices.css';


class AvailableServices extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  redirectURL = `${adminEndpoint}/available_services`;

  componentDidMount() {
    this.props.fetchAvailableServices();
  }
  

  render() {
    const available = this.props.availableServices;
    return (
      <div>
        {available.map((v, i) => <div key={i} className="col-sm-4"><PaperTile href={`${adminEndpoint}/available_services/${v.id}`} herb={v.iconURL} epuap={v.requiresEPUAP} text={v.title} /></div>)}
      </div>
    );
  }
}

const mapState = (state) => ({
  availableServices: state.eservices.availableServices,
});
const mapDispatch = {
  fetchAvailableServices,
};

export default withStyles(s)(connect(mapState, mapDispatch)(AvailableServices));



// WEBPACK FOOTER //
// src/routes/admin/available_services/AvailableServices.js